import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { LocalService } from '@core/services/local.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SocketAdapterService {
  private socketOption = {
    query: null,
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 20
    // agent: false,
    // upgrade: false,
    // rejectUnauthorized: false,
    // secure: true,
    // pingTimeout: 60000,
    // autoConnect: true
  };
  private url = environment.chatServer;
  public socket: Socket;
  private logoutSocket: Socket;
  private wsBaseUrl = environment.chatServer.replace('/socket.io', '');

  constructor(private localstorage: LocalService, public router: Router) {
    console.log('Constructing Socket IO');
    this.router.events.subscribe(() => {
      const user = this.localstorage.getObj('user');
      if (user && this.socketOption.query == null) {
        this.socketOption = {
          ...this.socketOption,
          query: {
            userId: user['id'],
            token: this.localstorage.getItem('jwt-token')
          }
        };
        console.log(this.url, this.socketOption);
        console.log(this.socket);
      }
    });
  }

  joinRoom(roomData: any) {
    console.log('Socket joining room : ', roomData);
    this.socket.emit('joinRoom', roomData);
  }

  register(userId) {
    console.log('Socket joining room : ', userId);
    this.socket.emit('register', userId);
  }

  receiveNotification(): Observable<string> {
    if(!this.socket) this.connect();
    return new Observable(observer => {
      this.socket.on('notification', data => {
        observer.next(data);
      });
    });
  }

  receivePageActiveUsers(): Observable<any[]> {
    return new Observable(observer => {
      this.socket.on('page:users', data => {
        observer.next(data);
      });
    });
  }

  emitUserEntered(data) {
    this.socket.emit('page:user-entered', data);
  }

  emitUserExit(data) {
    this.socket.emit('page:user-exit', data);
  }

  leaveRoom(roomData: any) {
    console.log('Socket leaving room: ', roomData);
    this.socket.emit('leaveRoom', roomData);
  }

  sendMessage(param: any) {
    this.socket.emit('send_message', param);
  }

  connect() {
    console.log('Socket Connecting...', this.url, this.socketOption);
    this.socket = io(this.url, this.socketOption);
    console.log('After Socket Connecting...');

    console.log(this.socket);
    return this.socket;
  }

  disconnect() {
    if (!!this.socket) {
      this.socket.disconnect();
    }
  }

  onConnect(): Observable<any> {
    console.log('Socket On Connect');
    return new Observable(observer => {
      this.socket.on('connect', () => {
        console.log('Socket new connect...');
        observer.next('connectd');
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  /*chat Socket starts*/

  sendPrivateMessage(message) {
    this.socket.emit('send-private-message', message);
  }

  getUserSession(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('get-user-sessions', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.localstorage.setItem('socketErrorKey', 'GSS');
      };
    });
  }

  recievePrivateMessage(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('receive-private-message', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.localstorage.setItem('socketErrorKey', 'RPM');
      };
    });
  }

  privateMessageAcknowledge(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('personal-message-ack', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.localstorage.setItem('socketErrorKey', 'PMA');
      };
    });
  }

  getUnreadMessages(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('get-unread-messages', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.localstorage.setItem('socketErrorKey', 'GUM');
      };
    });
  }

  readMessages(sender_id: number, receiver_id: number) {
    this.socket.emit('read-messages', { sender_id, receiver_id });
  }

  onType(param: any) {
    this.socket.emit('OnTyping', param);
  }

  isTyping(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('isTyping', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.localstorage.setItem('socketErrorKey', 'IT');
      };
    });
  }

  onReceiverReadsMessages(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('receiver-read-messages', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.localstorage.setItem('socketErrorKey', 'ORRM');
      };
    });
  }

  /*chat Socket ends*/

  onReConnect(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('reconnect', () => {
        observer.next('connectd');
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  onDisconnect() {
    return new Observable(observer => {
      this.socket.on('disconnected', () => {
        observer.next('disconnected');
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  onMessage(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('receive_message', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  onRoomNotification(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('room_notification', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  roomlistTyping(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('roomlist_typing', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  offlineUser(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('offline_user', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  onLine(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('online_user', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  updateStatus(status: any) {
    console.log('read_status : ', status);
    this.socket.emit('read_status', status);
  }
  messageStatus(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('recive_read_status', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }
  onUserRemovedFromGroup(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('remove_room', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  onRenameGroup(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('rename_group', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  receivePageData(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('receive_page_data', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  onlineEditPageUsers(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('online_edit_page_user', (data: any) => {
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }

  sendPageData(payload) {
    console.log('Sending page data');
    console.log(payload);
    this.socket.emit('send_page_data', payload);
  }

  receivedNotification(): Observable<any> {
    console.log('isConnected', this.socket?.connected);
    console.log('Connection established in adapter...');

    if (!this.socket?.connected) {
      this.connect();
    }
    return new Observable(observer => {
      this.socket.on('receive_message_data', (data: any) => {
        console.log('Data received in adapter...', data);
        observer.next(data);
      });
      return () => {
        this.socket.disconnect();
      };
    });
  }
  /**
   * Receive new message refresh event for in-app-message
   * This method listens for socket events when new messages arrive
   * @returns Observable that emits when a new message refresh event is received
   */
  receiveNewMessageRefresh(): Observable<any> {
    if (!this.socket || !this.socket.connected) {
      this.connect();
    }
    return new Observable(observer => {
      this.socket.on('new-message-refresh', (data: any) => {
        console.log('New message refresh event received:', data);
        observer.next(data);
      });
      return () => {
        // Cleanup: remove listener when unsubscribed
        if (this.socket) {
          this.socket.off('new-message-refresh');
        }
      };
    });
  }

  onForceLogout(): Observable<any> {
    if (!this.logoutSocket) {
      const user = this.localstorage.getObj('user');
      this.logoutSocket = io(`${this.wsBaseUrl}/nv-logout`, {
        path: '/socket.io',
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 20,
        query: {
          userId: user?.['id'],
          token: this.localstorage.getItem('jwt-token'),
        },
      });
      this.logoutSocket.on('connect', () => {
        this.logoutSocket.emit('register', String(user?.['id']));
      });
    }
    return new Observable(observer => {
      this.logoutSocket.on('force-logout', (data: any) => {
        observer.next(data);
      });
    });
  }
}
